var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgThumbsUpBlack(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 3.25L7.25 3.25L7.25 8.25H3.25L3.25 19.75L17.7776 19.75C19.1389 19.75 20.2953 18.7541 20.4972 17.4079L21.3972 11.4079C21.6466 9.74527 20.3589 8.25 18.6776 8.25L12.75 8.25V6C12.75 4.48122 11.5188 3.25 10 3.25ZM8.75 18.25H17.7776C18.3964 18.25 18.922 17.7973 19.0138 17.1854L19.9138 11.1854C20.0272 10.4297 19.4418 9.75 18.6776 9.75L11.25 9.75V6C11.25 5.30964 10.6904 4.75 10 4.75H8.75L8.75 18.25ZM7.25 18.25L7.25 9.75H4.75L4.75 18.25H7.25Z",
    fill: "#212121"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThumbsUpBlack);
export default __webpack_public_path__ + "static/media/thumbs-up-black.f528c247a227dcc6898358072b21ea1f.svg";
export { ForwardRef as ReactComponent };